import styled from "styled-components"
import media from "styled-media-query"

const Counter = styled.div`
  background-color: #e8f0fb;
  border-radius: 5px 5px 0 0;
  color: #0445a3;
  font-family: "Teko", sans-serif;
  font-size: 18px;
  font-weight: 700;
  height: 40px;
  line-height: 42px;
  letter-spacing: 2.7px;
  margin: auto 0 0 0;
  padding-top: 2px;
  text-align: center;
  width: 76px;
  ${media.greaterThan("small")`
    font-size: 24px;
    height: 48px;
    line-height: 48px;
    margin: auto 0 0 0;
    width: 120px;
  `}
`

export default Counter
